import React from 'react';
import '../App.css';
import {render} from 'react-dom';
import helm1 from './helm1.jpg';
import {ExternalLink} from 'react-external-link';


class Design extends React.Component{
    constructor(props){
        super(props);
    }
    render(){
        return(
            <>
                <div className="designPage">
                    <h1 className="designTitle">design.</h1>
                    <div >
                        <img className='designImage' src={helm1} alt="helm1" style={{width:'60%'}}/>
                    </div>
                    <div>
                        <p style={{ marginLeft:'7%',color:'white', fontSize:"2vw"}}>THE OSPREY</p>
                    </div>
                    
                    
                </div>
                <div className="designLower">
                    <div className="designBio">
                        <p>The one constant in my life is my appreciation for simple beauty,<br/> when the complex suddenly becomes elementary,<br/> it is in these astounding moments that the world seems clear.</p>
                    </div>
                    <div className="checkIt">
                        <p className="linkPara"><ExternalLink className="linkage" href="http://joshdiesenhaus.com/design">check it.</ExternalLink></p>
                    </div>
                </div>
            </>
        );
    }
}

export default Design;